<template>
  <div
    v-if="options && options.length"
    v-on-clickaway="onClickAway"
    class="single-select"
    :class="{'menu-open': !!showOptions}"
    @click="dropMenu">
    <div class="single-select__force-width">
      {{ longestOption }}
    </div>
    <div
      class="shadow full-width"
      :class="{'menu-open mdc-elevation--z8': !!showOptions}">
      <div
        class="chosen-value-wrap full-width">
        <div class="chosen-value full-width">
          {{ displayChosen }}
        </div>
      </div>
      <div
        v-if="showOptions"
        :level="8"
        class="dropdown options full-width">
        <div
          v-for="option in optionsDisplay"
          :key="option.value"
          class="option full-width"
          :value="option.value"
          @click="handleChoice(option.value)">
          {{ option.display }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'
import Elevation from 'material-components-vue/dist/elevation'

import Vue from 'vue'
Vue.use(Elevation)

export default {
  directives: {
    onClickaway: onClickaway
  },
  props: {
    handleChoice: {
      required: true,
      type: Function
    },
    options: {
      required: true,
      type: Array
    },
    upstreamVal: {
      required: true,
      type: [Number, Object, String]
    }
  },
  data () {
    return {
      showOptions: false,
      selectedVal: ''
    }
  },
  computed: {
    displayChosen () {
      try {
        return this.options.filter((option) => this.upstreamVal === option.value)[0].display
      } catch (e) {
        return ''
      }
    },
    longestOption () {
      const longest = this.options.reduce((longest, curr) => {
        return longest.display.length > curr.display.length ? longest : curr
      })
      return longest.display
    },
    optionsDisplay () {
      return this.options.filter((option) => {
        return this.displayChosen !== option.display
      })
    }
  },
  methods: {
    dropMenu () {
      this.showOptions = !this.showOptions
    },
    onClickAway () {
      this.showOptions = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../universal/vars.scss';
  @import 'material-components-vue/dist/elevation/styles';
  .single-select {
    display: inline-block;
    height: 36px;
    position: relative;
    cursor: pointer;
    z-index: 3;
    border-radius: 4px;

    &__force-width {
      height: 1px;
      visibility: hidden;
      margin-right: 44px;
    }
  }
  .menu-open {
    .chosen-value-wrap {
      background-color: $input-background;
    }
  }
  .shadow {
    border-radius: 4px;
    overflow: hidden;
    position: absolute;
    top: 0;
  }
  .chosen-value-wrap {
    height: 35px;
    line-height: 35px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }
  .chosen-value {
    position: relative;
    color: $black-medium-emphasis;
    margin-right: 12px;
    padding-left: 12px;
  }
  .chosen-value::after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid $black-medium-emphasis;

    position: absolute;
    right: 0;
    top: 14px;
    transition: transform 0.2s linear;
  }
  .menu-open .chosen-value::after, .menu-open:hover .chosen-value::after {
    transform: rotateZ(-180deg);
  }
  .options {
    color: $black-medium-emphasis;
    background-color: rgb(255, 255, 255);
    overflow: hidden;
  }
  .option {
    margin: 1px 0;
    padding: 8px 12px;
    color: $black-disabled;

    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      background-color: $input-background;
      color: $black-medium-emphasis;
    }
  }
</style>
